import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'atx-select-formly',
    template: `<atx-select [model]="data"
            (onTyped)="onTyped($event)"
            (onChange)="onChange($event)">
</atx-select>
`,
    styles: [``],
})

export class AtxSelectFormlyComponent extends FieldType {
    public data: object[];

    public onTyped(text) {
        ((this.to as { options }).options(text) as Observable<object[]>).subscribe((value) => this.data = value);
    }

    public onChange(element) {
        if (this.to.updateValue instanceof Function) {
            this.to.updateValue(this.formControl, element);
        } else {
            this.formControl.setValue(element);
        }
    }
}
